

import eventbus from '../../utils/eventbus';
import Base from '../base';

class ProductMaximumLeverageExceede extends Base {
	constructor(el) {
		super(el);

		this.onTick = this.onTick.bind(this);
	}

	start() {
		const { isin } = this.options;

		if (!isin) {
			console.warn('No ISIN passed');

			return;
		}

		eventbus.on(`tick:${isin}`, this.onTick);
	}

	get isVisible() {
		return !this.el.classList.contains('is-hidden');
	}

	set isVisible(isVisible) {
		this.el.classList.toggle('is-hidden', !isVisible);
	}

	onTick(tick) {
		const { IsMaximumLeverageExceeded } = tick;

		this.isVisible = IsMaximumLeverageExceeded;
	}
}

export default ProductMaximumLeverageExceede;
